import { TOAST_IDS, ToastType } from "@/modules/common/types";
import { downloadFile, showToast } from "@/modules/common/utils";
import { MenuItem } from "@mui/material";

export default function DownloadProposal({ fileUrl }: { fileUrl: string }) {
  const handleClick = () => {
    try {
      downloadFile(fileUrl);
      showToast({
        type: ToastType.SUCCESS,
        message: "Downloading started",
        toastId: TOAST_IDS.DOWNLOAD_DOCUMENT_SUCCESS,
      });
    } catch (error) {
      showToast({
        type: ToastType.ERROR,
        message: "Failed to download file",
        toastId: TOAST_IDS.DOWNLOAD_DOCUMENT_ERROR,
      });
    }
  };
  return (
    <MenuItem
      sx={(t) => t.nawy.typography.english.variants.body.md.regular}
      onClick={handleClick}
    >
      Download
    </MenuItem>
  );
}
